export const getEmojiURL = unified => (
  `https://s3-us-west-2.amazonaws.com/indemandly-assets/emoji-datasource-apple/64/${unified}.png`
)
